<template>
    <div style="cursor: help" @click.stop.prevent="$emit('onOpen', model)">

        <v-badge
            class="ma-0"
            bordered
            top
            color="red"
            overlap
            :dot="model.has_message ? true : false"
            :value="model.has_message"
            >
            <v-icon
                color="grey"
                :small="small"
                :dense="dense"
                >
                mdi-chat-processing-outline
                </v-icon>
            
        </v-badge>

    </div>
</template>

<script>
export default {
    name: 'EmcMessageBox',
    props: {
        model: {
            
        },
        small: { type: Boolean, default: true },
        dense: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false }
    },
}
</script>